import React, { useState } from 'react';

import IconEdit from '../../assets/images/common/icon-edit.svg';

import { ContactInputType } from '../../types/common/ContactType';
import { MasterInquireApiResponse } from '../../types/api/MasterInquireApiType';

import { ContactInput } from '../../pages/Contact/ContactInput';

type ConfirmationContactProps = {
    contactInput: ContactInputType; // 入力内容
    setContactInput: (value: ContactInputType) => void; // 入力内容setState
    inquireErrorMessage: string;
    textErrorMessage: string;
    masterInquireData: MasterInquireApiResponse;
};

export const ConfirmationContact: React.FC<ConfirmationContactProps> = ({
    contactInput,
    setContactInput,
    inquireErrorMessage,
    textErrorMessage,
    masterInquireData,
}) => {
    // 入力切替
    const [inputMode, setInputMode] = useState<boolean>(false);

    return (
        // 問い合わせからの遷移の場合の表示
        <>
            <div className='columns form-item_area'>
                <div className='column is-12'>
                    <div className='column-header'>
                        <h2>お問い合わせ内容</h2>
                        <button
                            className='button is-small editlist'
                            onClick={() => setInputMode(true)}
                            disabled={inputMode}
                        >
                            内容を修正する
                            <span className='icon is-small is-right'>
                                <img src={IconEdit} alt='' />
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <ContactInput
                dataInput={inputMode}
                contactInput={contactInput}
                setContactInput={setContactInput}
                inquireErrorMessage={inquireErrorMessage}
                textErrorMessage={textErrorMessage}
                masterInquireData={masterInquireData}
            />
        </>
    );
};
